// extracted by mini-css-extract-plugin
export default {"whatsappBtn":"WhatsAppButton_whatsappBtn__DTNFW","whatsappFloating":"WhatsAppButton_whatsappFloating__f-5b5","pulse":"WhatsAppButton_pulse__1yPrG"};